import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

type ModalState = Record<
  string,
  {
    visible: boolean;
    data?: any;
  }
>;

export type ChangeModalVisibilityActionPayload<T = unknown> = {
  visible: boolean;
  data?: T;
  modalName: string;
};

const initialState: ModalState = {};
const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    hideAllModals: () => initialState,
    changeModalVisibility: (
      state,
      action: PayloadAction<ChangeModalVisibilityActionPayload>,
    ) => {
      const { modalName, visible, data } = action.payload;
      if (visible) {
        state[modalName] = {
          visible,
          data,
        };
      } else {
        const modal = state[modalName];
        state[modalName] = {
          ...modal,
          visible: false,
        };
      }

      return state;
    },
  },
});

export const { hideAllModals, changeModalVisibility } = modalSlice.actions;

export default modalSlice.reducer;

export const selectModalState = (state: RootState) => state.modal;

/**
 * Given a modal indentifier generates a selector that returns
 * the modal payload
 * @param modalName A valid modal identifier.
 */
export const makeSelectModalState = (modalName: string) => (state: RootState) =>
  selectModalState(state)[modalName];
